import { render, staticRenderFns } from "./NavigatorBottomBarLinkProfile.vue?vue&type=template&id=f610249a"
import script from "./NavigatorBottomBarLinkProfile.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarLinkProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports